export const SUITE = [
  {
    name: "WSafe AI",
    desc: "AI hazard detection on existing cameras.",
    domain: "wsafe.ai",
    icon: "/brand/products/wsafe-ai-icon.svg",
  },
  {
    name: "HazardLoop",
    desc: "Corrective action tracking and verified closeout.",
    domain: "hazardloop.com",
    icon: "/brand/products/hazardloop-icon.svg",
  },
  {
    name: "InductIQ",
    desc: "Induction/training verification and incident reporting.",
    domain: "inductiq.ai",
    icon: "/brand/products/inductiq-icon.svg",
  },
  {
    name: "EnviSafe",
    desc: "Environmental conditions monitoring.",
    domain: "envisafe.ai",
    icon: "/brand/products/envisafe-icon.svg",
  },
  {
    name: "SafeForm",
    desc: "Ergonomic analysis.",
    domain: "safeform.ai",
    icon: "/brand/products/safeform-icon.svg",
  },
  {
    name: "WorkSafeStory",
    desc: "Safety stories and lessons learned.",
    domain: "worksafestory.com",
    icon: "/brand/products/worksafestory-icon.svg",
  },
];

export const MARQUEE_ITEMS = [
  "Upstream intervention",
  "Predictive safety intelligence",
  "No new hardware",
  "High-consequence sites",
  "Per-site SaaS",
  "Land · Prove · Expand",
];

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
